import store from "../../store";

const component = () => import("./Gestione.vue");
const beforeEnter = (to, from, next) => {
    if (!store.getters.isLoggedIn) return next("/login");
    if (from.meta.managementView && !Object.keys(to.query).length) {
        const query = { ...from.query };
        delete query.account; delete query.detailPeriod;
        if (Object.keys(query).length) return next({ name: to.name, query, replace: true });
    }
    return next();
};
export default [
    ["", "riepilogo", "Sintesi"],
    ["bilancio/", "bilancio", "Bilancio"],
    ["spese/", "spese", "Costi"],
    ["riconciliazione/", "riconciliazione", "Attendibilità dei dati"],
].map(([path, view, title]) => ({
    path: `/controllo-gestione/${path}`, name: `gestione-${view}`, component, beforeEnter,
    meta: { menu: "controllo_gestione", title, managementView: view, groups: ["Amministrazione"] },
})).concat({
    path: '/controllo-gestione/cespiti/',
    redirect: (to) => {
        const query = { ...to.query };
        if (!query.year && query.assetYear) query.year = query.assetYear;
        if (!query.month && query.assetMonth) query.month = query.assetMonth;
        delete query.assetYear; delete query.assetMonth; delete query.account; delete query.detailPeriod;
        return { name: 'gestione-riepilogo', query };
    },
});
